import { StaticSiteDataContext } from "../../../contexts/StaticSiteDataContext";
import { isEmptySlateDocument } from "../../../core/constants";
import { TextDetails } from "../../../resources/modelTypes";
import { SectionComponentProps } from "../../types";
import { ThemedRichText } from "./ThemedRichText";
import { SmallHeadline, TinyHeadline } from "@minted/fancyclothes";
import React, { memo, useContext } from "react";

const DisplayTextSection = ({ section }: SectionComponentProps) => {
  const { isWeddingSite } = useContext(StaticSiteDataContext);
  const details = section.sectionDetails as TextDetails;

  return (
    <>
      {Boolean(details.title) &&
        (isWeddingSite ? (
          <SmallHeadline>{details.title}</SmallHeadline>
        ) : (
          <TinyHeadline>{details.title}</TinyHeadline>
        ))}
      {!isEmptySlateDocument(details.content) && (
        <ThemedRichText content={details.content} />
      )}
    </>
  );
};

const MemoizedDisplayImageAndText = memo(DisplayTextSection);

export { MemoizedDisplayImageAndText as DisplayTextSection };
